import { UserReportsFormValues } from '../types';
import {
    IRestPutUserReportAssignments,
    IRestPutUserReportNewAssignment,
} from '@/app/services/reports';

export const buildAssignmentDifferences = (
    initial: UserReportsFormValues | undefined,
    current: UserReportsFormValues
): IRestPutUserReportAssignments => {
    // Take all entries with negative id and add them to added
    // name, typeId and templateId are required
    const newAssignments = Object.entries(current)
        .filter(([key]) => Number(key) < 0)
        .filter(
            ([, value]) =>
                value.name !== undefined &&
                value.typeId !== undefined &&
                value.templateId !== undefined
        )
        .map<IRestPutUserReportNewAssignment>(([, value]) => ({
            name: value.name ?? '',
            typeId: value.typeId ?? 0,
            templateId: value.templateId ?? 0,
        }));

    const diff: IRestPutUserReportAssignments = {};
    if (newAssignments.length > 0) {
        diff.added = newAssignments;
    }

    // Take all entries that exist in initial and are not in current
    if (initial) {
        const initialIds = Object.keys(initial)
            .map(Number)
            .filter((id) => id > 0); // only persisted assignments can be removed
        const currentIds = new Set(Object.keys(current).map((k) => Number(k)));

        const removed = initialIds
            .filter((id) => !currentIds.has(id))
            .map((assignmentId) => ({ assignmentId }));

        if (removed.length > 0) {
            diff.removed = removed;
        }
    }

    // Detect updated entries
    if (initial) {
        const updated = Object.entries(current)
            .map(([key, currVal]) => ({ id: Number(key), currVal }))
            .filter(({ id }) => id > 0)
            .filter(({ id }) => initial[id] !== undefined)
            .filter(({ id, currVal }) => {
                const initVal = initial[id];
                return (
                    initVal.name !== currVal.name ||
                    initVal.typeId !== currVal.typeId ||
                    initVal.templateId !== currVal.templateId
                );
            })
            .map(({ id, currVal }) => ({
                assignmentId: id,
                name: currVal.name ?? '',
                typeId: currVal.typeId ?? 0,
                templateId: currVal.templateId ?? 0,
            }));

        if (updated.length > 0) {
            diff.updated = updated;
        }
    }

    return diff;
};
